<template>
    <div class="listing-search">
        <header class="flex items-center justify-between mb-6">
            <div class="flex items-center space-x-3">
                <div class="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-slate-700 rounded transition-colors duration-300">
                    <svg class="w-5 h-5 text-blue-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                </div>
                <div>
                    <h1 class="text-lg font-semibold text-gray-800 dark:text-gray-100">Commercial Listing Search</h1>
                    <p class="text-sm text-gray-700 dark:text-gray-300">
                        Compare results from broker sites against an open-web search.
                    </p>
                </div>
            </div>
        </header>

        <search-form></search-form>

        <div v-if="errorMessage" class="mt-4 p-3 rounded bg-red-50 text-red-700 text-sm border border-red-200 dark:bg-red-900/20 dark:text-red-300 dark:border-red-800">
            {{ errorMessage }}
        </div>

        <market-intelligence
            v-if="searchState"
            class="mt-6"
            :criteria="criteria"
            :run-token="runToken"></market-intelligence>

        <results-compare v-if="searchState" class="mt-6"></results-compare>

        <div v-else-if="!isDispatching" class="mt-10 text-center text-sm text-gray-500 dark:text-gray-400">
            Pick a property type, square-footage range, and city/state to start.
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListingSearch',
    computed: {
        searchState()  { return this.$store.state.listingSearch.searchState; },
        isDispatching(){ return this.$store.state.listingSearch.isDispatching; },
        errorMessage() { return this.$store.state.listingSearch.errorMessage; },
        criteria()     { return this.$store.state.listingSearch.criteria; },
        // Bumps each time a new search dispatches — triggers
        // MarketIntelligence to re-fetch from the API.
        runToken()     { return this.$store.state.listingSearch.searchId || ''; },
    },
    beforeDestroy() {
        this.$store.dispatch('stopListingPolling');
    },
};
</script>
